/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Crisp_Bird_FlyInputs */

const en_wide_crisp_bird_fly = /** @type {(inputs: Wide_Crisp_Bird_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID or personnel number of the employee`)
};

const de_wide_crisp_bird_fly = /** @type {(inputs: Wide_Crisp_Bird_FlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID oder Personalnummer des Mitarbeiters`)
};

/**
* | output |
* | --- |
* | "ID or personnel number of the employee" |
*
* @param {Wide_Crisp_Bird_FlyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_crisp_bird_fly = /** @type {((inputs?: Wide_Crisp_Bird_FlyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Crisp_Bird_FlyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_crisp_bird_fly(inputs)
	return de_wide_crisp_bird_fly(inputs)
});